module.exports = __webpack_public_path__ + "img/zpd.5dda3e34.png";